import moment from 'moment';
import { useEffect, useState } from 'react';

import TableContainer from '../../../../../Components/Common/TableContainer';

import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';

import { columns } from './columns';
import { useMatch } from 'react-router';
import { getTansfersToEarnBet } from './slice';

export const Transfer = () => {
  const { transfers } = useAppSelector((state) => state.userDetails);

  const dispatch = useAppDispatch();

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    dispatch(getTansfersToEarnBet(Number(userId)));
  }, [dispatch, dispatch]);

  return (
    <>
      <TableContainer
        columns={columns}
        data={transfers || []}
        divClass='table-responsive table-card mb-1'
        tableClass='align-middle table-nowrap'
        theadClass='table-light text-muted'
      />
    </>
  );
};
